import DCMLogo from 'assets/dcm-logo.png';
import TTDLogo from 'assets/ttd-logo.png';
import AmazonLogo from 'assets/amazon-logo.svg';
import FacebookLogo from 'assets/facebook-logo.svg';
import LinkedinLogo from 'assets/linkedin-logo.svg';
import PinterestLogo from 'assets/pinterest-logo.svg';
import TwitterLogo from 'assets/twitter-logo.svg';
import DV360Logo from 'assets/dv360-logo.svg';
import InnovidLogo from 'assets/innovid-logo.png';
import { DV360_MAPPING_ACCESS,
    INNOVID_MAPPING_ACCESS,
    PINTEREST_MAPPING_ACCESS,
    TWITTER_MAPPING_ACCESS
} from 'constants/capabilities';

const platform = (text, value, logo, capability) => ({ text, value, image: { avatar: true, src: logo }, capability });

export const dcm = platform('DCM', 'dcm', DCMLogo);
export const ttd = platform('TTD', 'ttd', TTDLogo);
export const amazon = platform('Amazon', 'amazon', AmazonLogo);
export const facebook = platform('Facebook', 'facebook', FacebookLogo);
export const linkedin = platform('Linkedin', 'linkedin', LinkedinLogo);
export const pinterest = platform('Pinterest', 'pinterest', PinterestLogo, PINTEREST_MAPPING_ACCESS);
export const twitter = platform('Twitter', 'twitter', TwitterLogo, TWITTER_MAPPING_ACCESS);
export const dv360 = platform('DV360', 'dv360', DV360Logo, DV360_MAPPING_ACCESS);
export const innovid = platform('Innovid', 'innovid', InnovidLogo, INNOVID_MAPPING_ACCESS);

export const dv360DimensionCount = 6;
export const innovidDimensionCount = 10;

export const DELIVERY_PLATFORM_MAP = {
    dcm,
    ttd,
    amazon,
    facebook,
    linkedin,
    pinterest,
    dv360,
    twitter,
    innovid
};



// WEBPACK FOOTER //
// ./src/constants/platforms.js